import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Drawer,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  OutlinedInput,
  Stack,
  Typography,
} from "@mui/material";
import { useLocation } from "react-router-dom";
import SimpleBar from "simplebar-react";
import * as Yup from "yup";
import {
  addDoc,
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  serverTimestamp,
  updateDoc,
  where,
} from "firebase/firestore";
import { db, storage } from "../../../../firebaseConfig";
import { FieldArray, FormikProvider, useFormik } from "formik";
import { toast } from "react-toastify";
import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";
import Countries from "../../../../Contries.json";
import FileUploaderMultiple from "../../../../components/common/FileUploaderMultiple";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import StoreStepperContext from "../../../../context/storeStepperContext";

const validationSchema = Yup.object().shape({
  brandName: Yup.string().required("Brand name is required!"),
  aboutBrand: Yup.string().required("About Brand is required!"),
  brandLogo: Yup.string().required("Brand logo is required!"),
  brandCategory: Yup.string().required("Brand category is required!"),
  brandLocation: Yup.string().required("Brand location is required!"),
});

export default function AddBrand({ open, onClose, productCategory }) {
  const initialValue = {
    brandLink: "",
    brandAffiliateLink: "",
    brandName: "",
    aboutBrand: "",
    brandCurrency: "",
    isRestricted: false,
    notAffiliateLink: false,
    restriction: {
      heading: [""],
      // statement: "",
      waysToBypass: [""],
    },
    isPopular: false,
    brandLogo: "",
    bannerLogo: "",
    brandCategory: productCategory || "",
    brandLocation: "",
    integratedPartner: "",
    brandStatus: "",
  };
  const { serBrandReload } = useContext(StoreStepperContext);
  const [brandCtgry, setBrandCtgry] = useState([]);
  const [loading, setLoading] = useState(false);
  const [initialValues, setInitialValues] = useState(initialValue);
  const [selectedFiles, setSelectedFiles] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const getForId = async () => {
      if (location?.state?.id) {
        const docRef = doc(db, "brands", location?.state?.id);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setInitialValues({
            ...docSnap.data(),
            notAffiliateLink: docSnap.data().notAffiliateLink
              ? docSnap.data().notAffiliateLink
              : false,
          });
          // setInitialValues(docSnap.data());
        } else {
          console.log("No such document!");
        }
      }
    };
    getForId();
  }, [location?.state?.id]);

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema,

    onSubmit: async (values) => {
      setLoading(true);
      const q = query(
        collection(db, "brands"),
        where("isDeleted", "==", false),
        where("brandLogo", "==", values.brandLogo.trim())
      );
      const querySnapshot = await getDocs(q);
      let arr = [];
      querySnapshot.forEach((doc) => {
        arr.push({ ...doc.data(), id: doc.id });
      });
      console.log(arr,"arrrrrrrrrrrrrrrrrrrrrrrrrr")
      if (arr.length <= 0 || arr[0]?.id === location?.state?.id) {
        try {
          if (location?.state?.id) {
            //  logic for update
            if (typeof values.bannerLogo === "object") {
              const render = new FileReader();
              render.onload = (event) => {
                const img = new Image();
                img.onload = async () => {
                  const width = img.width;
                  const height = img.height;
                  if (width - height < 200) {
                    toast.error("Please select other image");
                    setLoading(false);
                    return;
                  } else {
                    const storageRef = ref(
                      storage,
                      `/brandBannerImages/${values.bannerLogo?.name}`
                    );
                    await uploadBytesResumable(storageRef, values.bannerLogo);
                    const url = await getDownloadURL(storageRef);
                    values.bannerLogo = url;
                    updateDoc(
                      doc(db, "brands", location.state.id),
                      values
                    ).then((res) => {
                      toast.success("Brand updated Successfully");
                      onClose();
                      setLoading(false);
                      serBrandReload(true);
                    });
                  }
                };
                img.src = event.target.result;
              };
              render.readAsDataURL(values.bannerLogo);
            } else {
              updateDoc(doc(db, "brands", location.state.id), values).then(
                (res) => {
                  toast.success("Brand updated Successfully");
                  onClose();
                  setLoading(false);
                }
              );
            }
          } else {
            if (typeof values.bannerLogo === "object") {
              const render = new FileReader();
              render.onload = (event) => {
                const img = new Image();
                img.onload = async () => {
                  const width = img.width;
                  const height = img.height;
                  if (width - height < 200) {
                    toast.error("Please select other image");
                    // return;
                  } else {
                    const storageRef = ref(
                      storage,
                      `/brandBannerImages/${values.bannerLogo?.name}`
                    );
                    await uploadBytesResumable(storageRef, values.bannerLogo);
                    const url = await getDownloadURL(storageRef);
                    values.bannerLogo = url;
                    const docRef = await addDoc(collection(db, "brands"), {
                      ...values,
                      dealId: [],
                      createdAt: serverTimestamp(),
                      updatedAt: serverTimestamp(),
                      followers: 0,
                      isDeleted: false,
                    }).then(async (res) => {
                      toast.success("Brand added Successfully");
                      onClose();
                      setLoading(false);
                      serBrandReload(true);
                      await updateDoc(doc(db, "brands", res.id), {
                        id: res.id,
                      });
                    });
                  }
                };
                img.src = event.target.result;
              };
              render.readAsDataURL(values.bannerLogo);
            } else {
              const docRef = await addDoc(collection(db, "brands"), {
                ...values,
                dealId: [],
                createdAt: serverTimestamp(),
                updatedAt: serverTimestamp(),
                followers: 0,
                isDeleted: false,
              }).then(async (res) => {
                toast.success("Brand added Successfully");
                onClose();
                serBrandReload(true);
                setLoading(false);
                await updateDoc(doc(db, "brands", res.id), {
                  id: res.id,
                });
              });
            }
          }
        } catch (error) {
          console.log(error, "error");
          setLoading(false);
        }
      } else {
        toast.error("This Brand name is already exists");
        setLoading(false);
      }
    },
  });

  useEffect(() => {
    // handler();
    handlerTwo();
  }, []);

  async function handlerTwo() {
    try {
      const querySnapshot = await getDocs(collection(db, "brandCategory"));
      let array = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setBrandCtgry(array);
      //   setRoutePartnerDoc(arr);
    } catch (error) {
      console.log(error, "error");
    }
  }

  const countryChangeHandler = (event) => {
    formik.handleChange(event);

    // eslint-disable-next-line eqeqeq
    const country = Countries.find((item) => item.name == event.target.value);

    formik.setFieldValue(
      "brandCurrency",
      `${country.currency} (${country?.currencySymbol})`
    );
  };

  const onUploadChange = (file) => {
    setSelectedFiles(file);
    formik.setFieldValue("bannerLogo", file[0]);
  };

  return (
    <Drawer
      variant="temporary"
      anchor="right"
      open={open}
      onClose={onClose}
      BackdropProps={{
        sx: { background: "rgba(0, 0, 0, 0.5)" },
      }}
      PaperProps={{
        sx: { width: "1200px" }, // Adjust the width here
      }}
    >
      <form onSubmit={formik.handleSubmit}>
        <Box
          sx={{
            margin: "0 10px",
            padding: "0 10px",
          }}
        >
          <Box sx={{ borderBottom: "1px solid #E5E5E8" }}>
            <Box
              sx={{
                borderBottom: "1px solid #E5E5E8",
                paddingLeft: "20px",
                paddingTop: "20px",
                paddingBottom: "20px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography variant="h4" component="h4">
                Add Brand
              </Typography>
            </Box>
          </Box>
          <SimpleBar
            forceVisible="y"
            autoHide={true}
            style={{
              maxHeight: "82vh",
            }}
            className="custom-scrollbar"
          >
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <Box>
                  <Stack direction={"row"} sx={{ marginTop: "20px" }}>
                    <Stack>
                      <Box sx={{ marginBottom: "10px" }}>
                        <Typography
                          sx={{ fontSize: "13px", fontWeight: "600" }}
                        >
                          Brand Link
                        </Typography>
                      </Box>
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <FormControl
                          fullWidth
                          sx={{
                            m: 1,
                            minWidth: "30vw",
                            minHeight: "35px",
                            marginLeft: "0px",
                          }}
                          size="small"
                        >
                          <OutlinedInput
                            fullWidth
                            type="text"
                            id="brandLink"
                            placeholder="Brand Link"
                            onChange={formik.handleChange}
                            name="brandLink"
                            value={formik.values.brandLink}
                          />
                        </FormControl>
                        <Button
                          onClick={() =>
                            formik.setFieldValue(
                              "brandLogo",
                              `https://img.logo.dev/${formik.values.brandLink}?token=pk_MTpJJ106SOiZiZ9kwYu61g`
                            )
                          }
                          // eslint-disable-next-line eqeqeq
                          disabled={
                            // eslint-disable-next-line eqeqeq
                            formik.values.brandLink == "" ? true : false
                          }
                          sx={{
                            width: "160px",
                            border: "1px solid #E5E5E8",
                            color: "black",
                          }}
                        >
                          Get Logo
                        </Button>
                      </Box>

                      <Grid item xs={12} md={6}>
                        <Box>
                          <Box sx={{ marginY: "14px" }}>
                            <Typography
                              sx={{ fontSize: "13px", fontWeight: "600" }}
                            >
                              Logo
                            </Typography>
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              // height: "128px",
                              // width: "128px",
                              padding: "10px",
                              border: "1px solid #481AA3",
                              borderRadius: "8px",
                            }}
                          >
                            {!formik.values.brandLogo && (
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  width: "100%",
                                }}
                              >
                                <CircularProgress size={25} />
                              </Box>
                            )}
                            {formik.values.brandLogo && (
                              <img
                                src={formik.values.brandLogo}
                                alt="logo"
                                height="36px"
                              />
                            )}
                          </Box>
                          {formik.touched.brandLogo &&
                            formik.errors.brandLogo && (
                              <span
                                className="small text-danger"
                                style={{ color: "red" }}
                              >
                                {formik.errors.brandLogo}
                              </span>
                            )}
                        </Box>
                      </Grid>

                      {formik.touched.brandLink && formik.errors.brandLink && (
                        <span
                          className="small text-danger"
                          style={{ color: "red" }}
                        >
                          {formik.errors.brandLink}
                        </span>
                      )}

                      <Typography
                        sx={{ fontSize: "13px", fontWeight: "600", mt: 2 }}
                      >
                        Brand Affiliate Link
                      </Typography>
                      <FormControl
                        fullWidth
                        sx={{
                          m: 1,
                          minWidth: "30vw",
                          minHeight: "35px",
                          marginLeft: "0px",
                        }}
                        size="small"
                      >
                        <OutlinedInput
                          fullWidth
                          type="text"
                          id="brandAffiliateLink"
                          placeholder="Brand Affiliate Link"
                          onChange={formik.handleChange}
                          name="brandAffiliateLink"
                          value={formik.values.brandAffiliateLink}
                          disabled={formik.values.notAffiliateLink}
                        />
                      </FormControl>
                    </Stack>
                  </Stack>
                  <Box>
                    <FormControlLabel
                      control={
                        <Checkbox
                          onChange={formik.handleChange}
                          name="notAffiliateLink"
                          checked={formik.values.notAffiliateLink}
                        />
                      }
                      label="Not Affiliate link"
                    />
                  </Box>
                  <Grid item xs={12} md={6}>
                    <Typography
                      sx={{ fontSize: "13px", fontWeight: "600", my: 2 }}
                    >
                      Banner
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        width: "100%",
                      }}
                    >
                      <FileUploaderMultiple
                        name={"images"}
                        value={formik.values.bannerLogo}
                        onChange={onUploadChange}
                      />
                    </Box>
                    {formik.touched.bannerLogo && formik.errors.bannerLogo && (
                      <span
                        className="small text-danger"
                        style={{ color: "red" }}
                      >
                        {formik.errors.bannerLogo}
                      </span>
                    )}
                  </Grid>
                  <Stack direction={"row"} sx={{ marginTop: "20px" }} gap={3}>
                    <Grid item xs={12} md={6}>
                      <Box sx={{ marginBottom: "15px" }}>
                        <Typography
                          sx={{ fontSize: "13px", fontWeight: "600" }}
                        >
                          Category
                        </Typography>
                      </Box>
                      <FormControl sx={{ minWidth: 120 }} fullWidth>
                        <select
                          removeItemButton
                          name="brandCategory"
                          onChange={formik.handleChange}
                          value={formik.values.brandCategory}
                          // defaultValue={formik.values.country}
                          className="w-full"
                          style={{
                            height: "44px",
                            border: "1px solid #d2d4e4",
                            borderRadius: "0.45rem",
                            padding: "0.5625rem 0.9rem",
                            fontSize: "0.875rem",
                            color: "#43476b",
                            outline: "0",
                          }}
                          onFocus={(e) => {
                            e.target.style.borderColor =
                              "rgba(95, 56, 249, 0.65)";
                            e.target.style.boxShadow =
                              "0 0 5px 0px rgba(95, 56, 249, 0.2)";
                          }}
                          onBlur={(e) => {
                            e.target.style.borderColor = "#d2d4e4";
                            e.target.style.boxShadow = "none";
                          }}
                        >
                          <option value="">Select an category</option>
                          {brandCtgry?.map((ctgry, i) => (
                            <option key={i} value={ctgry.name}>
                              {ctgry.name}
                            </option>
                          ))}
                        </select>
                      </FormControl>
                      {formik.touched.brandCategory &&
                        formik.errors.brandCategory && (
                          <span
                            className="small text-danger"
                            style={{ color: "red" }}
                          >
                            {formik.errors.brandCategory}
                          </span>
                        )}
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Box sx={{ marginBottom: "10px" }}>
                        <Typography
                          sx={{ fontSize: "13px", fontWeight: "600" }}
                        >
                          Brand Name
                        </Typography>
                      </Box>
                      <FormControl
                        fullWidth
                        sx={{
                          mt: 1,
                          minWidth: "20vw",
                          minHeight: "35px",
                          marginLeft: "0px",
                        }}
                        size="small"
                      >
                        <OutlinedInput
                          type="text"
                          id="brandName"
                          placeholder="Brand Name"
                          onChange={formik.handleChange}
                          name="brandName"
                          value={formik.values.brandName}
                        />
                      </FormControl>
                      {formik.touched.brandName && formik.errors.brandName && (
                        <span style={{ color: "red" }}>
                          {formik.errors.brandName}
                        </span>
                      )}
                    </Grid>
                  </Stack>
                  <Stack direction={"row"} sx={{ marginTop: "20px" }} gap={3}>
                    <Grid item xs={12} md={6}>
                      <Box sx={{ marginBottom: "15px" }}>
                        <Typography
                          sx={{ fontSize: "13px", fontWeight: "600" }}
                        >
                          Location
                        </Typography>
                      </Box>
                      <FormControl sx={{ minWidth: 120 }} fullWidth>
                        <select
                          removeItemButton
                          name="brandLocation"
                          onChange={countryChangeHandler}
                          value={formik.values.brandLocation}
                          // defaultValue={formik.values.country}
                          className="w-100"
                          style={{
                            height: "44px",
                            border: "1px solid #d2d4e4",
                            borderRadius: "0.45rem",
                            padding: "0.5625rem 0.9rem",
                            fontSize: "0.875rem",
                            color: "#43476b",
                            outline: "0",
                          }}
                          onFocus={(e) => {
                            e.target.style.borderColor =
                              "rgba(95, 56, 249, 0.65)";
                            e.target.style.boxShadow =
                              "0 0 5px 0px rgba(95, 56, 249, 0.2)";
                          }}
                          onBlur={(e) => {
                            e.target.style.borderColor = "#d2d4e4";
                            e.target.style.boxShadow = "none";
                          }}
                        >
                          <option value={""}>Select Country</option>
                          {Countries.map((country, i) => (
                            <option key={i} value={country.name}>
                              {country.name}
                            </option>
                          ))}
                        </select>
                      </FormControl>
                      {formik.touched.brandLocation &&
                        formik.errors.brandLocation && (
                          <span
                            className="small text-danger"
                            style={{ color: "red" }}
                          >
                            {formik.errors.brandLocation}
                          </span>
                        )}
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Box sx={{ marginBottom: "10px" }}>
                        <Typography
                          sx={{ fontSize: "13px", fontWeight: "600" }}
                        >
                          Currency
                        </Typography>
                      </Box>
                      <FormControl
                        fullWidth
                        sx={{
                          m: 1,
                          minWidth: "20vw",
                          minHeight: "35px",
                          marginLeft: "0px",
                        }}
                        size="small"
                      >
                        <OutlinedInput
                          placeholder="Brand Currency"
                          name="brandCurrency"
                          value={formik.values.brandCurrency}
                          disabled={true}
                        />
                      </FormControl>
                    </Grid>
                  </Stack>
                  <Stack direction={"row"} sx={{ marginTop: "20px" }} gap={3}>
                    <Grid item xs={12} md={6}>
                      <Box sx={{ marginBottom: "10px" }}>
                        <Typography
                          sx={{ fontSize: "13px", fontWeight: "600" }}
                        >
                          Is Integrated Partner
                        </Typography>
                      </Box>
                      <FormControl sx={{ minWidth: 120 }} fullWidth>
                        <select
                          removeItemButton
                          name="integratedPartner"
                          onChange={formik.handleChange}
                          value={formik.values.integratedPartner}
                          // defaultValue={formik.values.country}
                          className="w-100"
                          style={{
                            height: "44px",
                            border: "1px solid #d2d4e4",
                            borderRadius: "0.45rem",
                            padding: "0.5625rem 0.9rem",
                            fontSize: "0.875rem",
                            color: "#43476b",
                            outline: "0",
                          }}
                          onFocus={(e) => {
                            e.target.style.borderColor =
                              "rgba(95, 56, 249, 0.65)";
                            e.target.style.boxShadow =
                              "0 0 5px 0px rgba(95, 56, 249, 0.2)";
                          }}
                          onBlur={(e) => {
                            e.target.style.borderColor = "#d2d4e4";
                            e.target.style.boxShadow = "none";
                          }}
                        >
                          <option value="">Select an option</option>
                          <option value="Yes">Yes</option>
                          <option value="No">No</option>
                        </select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Box sx={{ marginBottom: "10px" }}>
                        <Typography
                          sx={{ fontSize: "13px", fontWeight: "600" }}
                        >
                          Status
                        </Typography>
                      </Box>
                      <FormControl sx={{ minWidth: 120 }} fullWidth>
                        <select
                          removeItemButton
                          name="brandStatus"
                          onChange={formik.handleChange}
                          value={formik.values.brandStatus}
                          // defaultValue={formik.values.country}
                          className="w-100"
                          style={{
                            height: "44px",
                            border: "1px solid #d2d4e4",
                            borderRadius: "0.45rem",
                            padding: "0.5625rem 0.9rem",
                            fontSize: "0.875rem",
                            color: "#43476b",
                            outline: "0",
                          }}
                          disabled={
                            formik.values.brandStatus.toLowerCase() ===
                            "pending"
                          }
                          onFocus={(e) => {
                            e.target.style.borderColor =
                              "rgba(95, 56, 249, 0.65)";
                            e.target.style.boxShadow =
                              "0 0 5px 0px rgba(95, 56, 249, 0.2)";
                          }}
                          onBlur={(e) => {
                            e.target.style.borderColor = "#d2d4e4";
                            e.target.style.boxShadow = "none";
                          }}
                        >
                          <option value="">Select an option</option>
                          <option value="Active">Active</option>
                          <option value="InActive">InActive</option>
                        </select>
                      </FormControl>
                    </Grid>
                  </Stack>
                  <Stack direction={"row"} sx={{ marginTop: "20px" }} gap={3}>
                    <Grid item xs={12}>
                      <Box sx={{ marginBottom: "10px" }}>
                        <Typography
                          sx={{ fontSize: "13px", fontWeight: "600" }}
                        >
                          About brand
                        </Typography>
                      </Box>
                      <FormControl
                        fullWidth
                        sx={{
                          m: 1,
                          minWidth: "42vw",
                          minHeight: "35px",
                          marginLeft: "0px",
                        }}
                        size="small"
                      >
                        <OutlinedInput
                          multiline
                          minRows={5}
                          name="aboutBrand"
                          onChange={formik.handleChange}
                          value={formik.values.aboutBrand}
                        />
                      </FormControl>
                      {formik.touched.aboutBrand &&
                        formik.errors.aboutBrand && (
                          <span
                            className="small text-danger"
                            style={{ color: "red" }}
                          >
                            {formik.errors.aboutBrand}
                          </span>
                        )}
                    </Grid>
                  </Stack>
                  <Box>
                    <FormControlLabel
                      control={
                        <Checkbox
                          onChange={formik.handleChange}
                          name="isPopular"
                          // value={formik.values.isPopular}
                          checked={formik.values.isPopular}
                        />
                      }
                      label="Is this store popular ?"
                    />
                  </Box>
                  <Box>
                    <FormControlLabel
                      control={
                        <Checkbox
                          onChange={formik.handleChange}
                          name="isRestricted"
                          // value={formik.values.isRestricted}
                          checked={formik.values.isRestricted}
                        />
                      }
                      label="Add Restriction"
                    />
                  </Box>

                  <FormikProvider value={formik}>
                    {formik.values.isRestricted && (
                      <FieldArray name="restriction.heading">
                        {(arrayHelpers) => {
                          return (
                            <>
                              <Box
                                sx={{
                                  marginY: "10px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                }}
                              >
                                <Typography
                                  sx={{ fontSize: "13px", fontWeight: "600" }}
                                >
                                  Restriction Heading
                                </Typography>
                                <IconButton
                                  aria-label="plus"
                                  onClick={() => arrayHelpers.push("")}
                                  sx={{
                                    height: "20px",
                                    width: "20px",
                                    backgroundColor: "#481AA3",
                                    color: "#fff",
                                    ":hover": {
                                      backgroundColor: "#400ca7",
                                    },
                                  }}
                                >
                                  <AddIcon fontSize="small" />
                                </IconButton>
                              </Box>
                              <Stack gap={1}>
                                {formik.values.restriction.heading?.map(
                                  (rest, index) => {
                                    return (
                                      <>
                                        <FormControl
                                          fullWidth
                                          sx={{
                                            display: "flex",
                                            flexDirection: "row",
                                            alignItems: "center",
                                          }}
                                          size="small"
                                        >
                                          <OutlinedInput
                                            fullWidth
                                            type="text"
                                            placeholder="Restriction Heading"
                                            onChange={formik.handleChange}
                                            name={`restriction.heading[${index}]`}
                                            value={rest}
                                          />
                                          {formik.values.restriction.heading
                                            ?.length > 1 && (
                                            <IconButton
                                              aria-label="delete"
                                              onClick={() =>
                                                arrayHelpers.pop("")
                                              }
                                              sx={{
                                                height: "20px",
                                                width: "20px",
                                                marginLeft: "10px",
                                                backgroundColor: "#EB5757",
                                                color: "#fff",
                                                ":hover": {
                                                  backgroundColor: "#EB5757",
                                                },
                                              }}
                                            >
                                              <RemoveIcon fontSize="small" />
                                            </IconButton>
                                          )}
                                        </FormControl>
                                      </>
                                    );
                                  }
                                )}
                              </Stack>
                            </>
                          );
                        }}
                      </FieldArray>
                    )}
                  </FormikProvider>

                  <FormikProvider value={formik}>
                    {formik.values.isRestricted && (
                      <FieldArray name="restriction.waysToBypass">
                        {(arrayHelpers) => {
                          return (
                            <>
                              <Box
                                sx={{
                                  mt: "25px",
                                  mb: "10px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                }}
                              >
                                <Typography
                                  sx={{ fontSize: "13px", fontWeight: "600" }}
                                >
                                  Ways to bypass
                                </Typography>
                                <IconButton
                                  aria-label="plus"
                                  onClick={() => arrayHelpers.push("")}
                                  sx={{
                                    height: "20px",
                                    width: "20px",
                                    backgroundColor: "#481AA3",
                                    color: "#fff",
                                    ":hover": {
                                      backgroundColor: "#400ca7",
                                    },
                                  }}
                                >
                                  <AddIcon fontSize="small" />
                                </IconButton>
                              </Box>
                              <Stack gap={1}>
                                {formik.values.restriction.waysToBypass.map(
                                  (rest, index) => {
                                    return (
                                      <>
                                        <FormControl
                                          fullWidth
                                          sx={{
                                            display: "flex",
                                            flexDirection: "row",
                                            alignItems: "center",
                                          }}
                                          size="small"
                                        >
                                          <OutlinedInput
                                            fullWidth
                                            type="text"
                                            placeholder="Ways to bypass"
                                            onChange={formik.handleChange}
                                            name={`restriction.waysToBypass[${index}]`}
                                            value={rest}
                                          />
                                          {formik.values.restriction
                                            .waysToBypass?.length > 1 && (
                                            <IconButton
                                              aria-label="delete"
                                              onClick={() =>
                                                arrayHelpers.pop("")
                                              }
                                              sx={{
                                                height: "20px",
                                                width: "20px",
                                                marginLeft: "10px",
                                                backgroundColor: "#EB5757",
                                                color: "#fff",
                                                ":hover": {
                                                  backgroundColor: "#EB5757",
                                                },
                                              }}
                                            >
                                              <RemoveIcon fontSize="small" />
                                            </IconButton>
                                          )}
                                        </FormControl>
                                      </>
                                    );
                                  }
                                )}
                              </Stack>
                            </>
                          );
                        }}
                      </FieldArray>
                    )}
                  </FormikProvider>
                </Box>
              </Grid>
            </Grid>
          </SimpleBar>
          {/* <Grid item xs={12} textAlign={"right"}> */}
          <Box
            sx={{
              textAlign: "right",
            }}
          >
            <Button
              variant="contained"
              sx={{
                backgroundColor: "white",
                color: "#1C2630",
                border: "1px solid #E5E5E8",
                minWidth: "126px",
                borderRadius: "4px",
                boxShadow: "none",
                whiteSpace: "nowrap",
                fontWeight: 600,
                marginTop: "20px",
                "&:hover": {
                  outline: "none",
                  color: "#1C2630",
                  backgroundColor: "white",
                },
              }}
              onClick={onClose}
            >
              Close
            </Button>
            <Button
              variant="contained"
              loading={loading}
              type="submit"
              sx={{
                backgroundColor: "#5E17EB",
                color: "#fff",
                marginLeft: "20px",
                minWidth: "126px",
                border: "1px solid #E5E5E8",
                borderRadius: "4px",
                boxShadow: "none",
                whiteSpace: "nowrap",
                fontWeight: 600,
                marginTop: "20px",
                "&:hover": {
                  outline: "none",
                  color: "#fff",
                  backgroundColor: "#5E17EB",
                },
              }}
            >
              Save
            </Button>
          </Box>
          {/* </Grid> */}
        </Box>
      </form>
    </Drawer>
  );
}
